import { randomUsers } from "../pages/category/mock";

export const generateUser = () => {
    const int = getRandomInt(0,16);
    return randomUsers[int]
}

export const generateRandomUser = () => {
    const int = getRandomInt(0,16);
    return randomUsers[int]
}

export const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}


export const generateRandomNDigits = (n) => {
    return Math.floor(Math.random() * (9 * (Math.pow(10, n)))) + (Math.pow(10, n));
}

export const randomBinary = (min, max) => {
    return Math.floor(min + Math.random() * (max + 1 - min)).toString(2);
}

export const getTime = (date) => date // && format(new Date(date), 'd/M/Y')
